import React, { Component } from 'react';
import Form from 'react-web-formo';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { customAlphabet } from 'nanoid';
import { Button } from '@mui/material';
import moment from 'moment';
import * as _ from 'lodash';
// import { createBrowserHistory } from 'history';

import Spinner from '../../../../common/spinner';
import SnackbarMessage from '../../../../common/snackbarMessage';
import * as types from '../../../../actions/types';
import {
  resetErrorMessage,
  resetSuccessMessage,
} from '../../../userOnBoarding/actions/actions';
import {
  getReportDetails,
  createFormData,
  setExtProps,
  getFormDataDetails,
  updateFormData,
  setSelectedFieldValue,
  handleImagesUploadAndDownload,
  handleDocumentUpload,
  getTeamDesignations,
  getOTPForForm,
  getAutoIncrCurrMaxLimit,
} from '../../actions/report';
import {
  isNull,
  unsupportedMessage,
  getPickerDesigOptions,
  getPickerDefaultValue,
  validateEmail,
  validateMobNumber,
  getUserDefaultValue,
  formatUserFilterQuery,
} from '../../../../utils/helper';
import {
  getTeamUserDetails,
  getUserDirectoryDesignation,
} from '../../actions/home';
import Catalog from './../catalog';
import Lookup from './../lookup';
import Checklist from './../checklist';
import Select from './../select';
import UserDirectory from './../userDirectory';
import ImagePreviewModal from './../inbox/imagePreviewModal';
import AlertDailog from './../../component/alertDailog';
import SignatureModal from '../inbox/signatureModal';
import {
  deleteDocumentFile,
  downloadDocument,
  getAssignmentType,
  processUserDirectoryField,
} from './helper';
import { setCustomToken } from './../../../../fireStoreConfig/fireStore';
import AutoIncrModal from './autoIncrModal';
import '../../styles/form/createForm.css';
import withRouter from 'withRouter';

const nanoid = customAlphabet(
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@',
  10
);

interface IState {
  fields: any[];
  templateName: string;
  openCatalogModal: boolean;
  extProps: any;
  openLookupModal: boolean;
  formData: any;
  openChecklistModal: boolean;
  openSelectModal: boolean;
  openUserDirectoryModal: boolean;
  attachmentUploadStatus: string;
  isImagePicked: boolean;
  openImgModal: boolean;
  modalImgData: any;
  openAlertDialog: boolean;
  alertMessage: string;
  docUpload: boolean;
  deleteDocument: boolean;
  deleteDocDialog: boolean;
  deleteDocData: any;
  refData: any;
  openSignatureModal: boolean;
  signatureAttributes: any;
  alertAutoIncrVisible: boolean;
  alertAutoIncrMsg: string;
  disableSubmitButton: boolean;
}

interface IProps {
  getReportDetailsSuccess: boolean;
  createFormDataSuccess: boolean;
  reportDetails: any;
  createFormDataResponse: any;
  reportDetailsSpinner: boolean;
  createFormDataSpinner: boolean;
  getFormDetails: boolean;
  getFormDetailsSpinner: boolean;
  formDataDetails: any;
  updateFormDataSuccess: boolean;
  updateFormDataSpinner: boolean;
  error: {
    displayMessage: string;
  };
  success: {
    displayMessage: string;
  };
  open: boolean;
  dispatch: Dispatch;
  resetErrorMessage: () => void;
  resetSuccessMessage: () => void;
  userTeamDetails: any;
  teamUserDetailsSuccess: boolean;
  timedOut: boolean;
  externalProps: any;
  getReportDetails: (templateId: string, teamId: string, resolve: any) => void;
  createFormData: (
    templateId: string,
    viewName: string,
    formData: any,
    isImagePicked: boolean
  ) => void;
  getTeamUserDetails: (teamId: string, userId: any) => void;
  setExtProps: (extProps: any) => void;
  getFormDataDetails: (
    templateId: string,
    instanceId: string,
    fields: any,
    isFromForm: boolean
  ) => void;
  updateFormData: (
    templateId: string,
    instanceId: string,
    viewName: string,
    formData: any,
    isImagePicked: boolean
  ) => void;
  selectedMsg: string;
  setSelectedFieldValue: any;
  handleImagesUploadAndDownload: any;
  handleDocumentUpload: any;
  teamdesignations: any;
  teamdesignationsSpinner: boolean;
  teamdesignationsSuccess: boolean;
  teamdesignationsFailure: boolean;
  getTeamDesignations: (teamId: string) => void;
  router: any;
  getOTPForForm: (
    userName: string,
    loginType: string,
    resolve: any,
    reject: any
  ) => void;
  getAutoIncrCurrMaxLimit: (templateId: string) => void;
  getAutoIncrReq: boolean;
  getAutoIncrSuccess: boolean;
  autoIncrDetails: any;
}

class Form1 extends Component<IProps, IState> {
  state = {
    fields: [],
    templateName: '',
    openCatalogModal: false,
    extProps: {},
    openLookupModal: false,
    formData: null,
    openChecklistModal: false,
    openSelectModal: false,
    openUserDirectoryModal: false,
    attachmentUploadStatus: 'done',
    isImagePicked: false,
    openImgModal: false,
    modalImgData: null,
    openAlertDialog: false,
    alertMessage: '',
    docUpload: false,
    deleteDocument: false,
    deleteDocDialog: false,
    deleteDocData: {},
    refData: {},
    openSignatureModal: false,
    signatureAttributes: null,
    alertAutoIncrVisible: false,
    alertAutoIncrMsg: '',
    disableSubmitButton: false,
  };
  startTime = moment().utc().valueOf();
  instanceId = nanoid();
  formGenerator: any;
  props: any;

  componentDidMount() {
    if (
      this.props.router.location.state &&
      this.props.router.location.state['fields']
    ) {
      this.setState(
        {
          fields: this.props.router.location.state['fields'],
          formData: this.props.router.location.state['fieldValues'],
          templateName: this.props.router.location.state['templateName'],
        },
        () => {
          /**
           * Clear history state fields
           */
          // const history = createBrowserHistory();
          // console.log(history);
          // const state: any = history.location.state || {};
          // delete state['fields'];
          // delete state['fieldValues'];
          // delete state['templateName'];
          // history.replace({ ...history.location, state });
        }
      );
      this.props.setExtProps(null);
      this.props.getTeamUserDetails(
        this.props.router.params.teamId,
        sessionStorage.getItem('userId')
      );
    } else {
      if (isNull(this.props.router.params.stageName)) {
        this.props.getAutoIncrCurrMaxLimit(this.props.router.params.templateId);
      }
      this.loadData().then(() => {
        if (!isNull(this.props.router.params.instanceId)) {
          this.props.getFormDataDetails(
            this.props.router.params.templateId,
            this.props.router.params.instanceId,
            this.getAllFields(),
            true
          );
        }
      });
    }

    setCustomToken(sessionStorage.getItem('accessToken'));
  }

  componentDidUpdate() {
    if (this.props.getReportDetailsSuccess) {
      this.props.dispatch({
        type: types.RESET_REPORT_DETAILS_REQUEST,
      });
      this.props.getTeamUserDetails(
        this.props.router.params.teamId,
        sessionStorage.getItem('userId')
      );
    }
    if (this.props.createFormDataSuccess) {
      if (!this.props.timedOut) {
        if (this.props.createFormDataResponse['_mo_instance_id']) {
          this.props.router.navigate(
            `/member/${this.props.router.params.teamId}/inbox/${this.props.router.params.templateId}/details/${this.props.createFormDataResponse['_mo_instance_id']}`
          );
        } else {
          this.props.router.navigate(`/member/home`);
        }
      }
      this.props.dispatch({
        type: types.RESET_CREATE_FORM_DATA_REQUEST,
      });
    }
    if (this.props.updateFormDataSuccess) {
      if (!this.props.timedOut) {
        this.props.router.navigate(
          `/member/${this.props.router.params.teamId}/inbox/${this.props.router.params.templateId}/details/${this.props.router.params.instanceId}`
        );
      }
      this.props.dispatch({
        type: types.RESET_UPDATE_FORM_DATA_REQUEST,
      });
    }
    if (this.props.getFormDetails) {
      this.props.dispatch({
        type: types.RESET_GET_FORM_DETAILS_REQUEST,
      });
      this.setState({
        formData: this.props.formDataDetails.data,
        refData: this.getOTPRefFieldData(
          this.getAllFields(),
          this.props.formDataDetails.data
        ),
      });
    }
    if (this.props.teamUserDetailsSuccess) {
      this.props.dispatch({
        type: types.RESET_GET_TEAM_USER_DETAILS_REQUEST,
      });
      const designationName =
        this.props.userTeamDetails && this.props.userTeamDetails.designation
          ? this.props.userTeamDetails.designation.designation_name
          : null;
      sessionStorage.setItem('desigName', designationName);
      this.props.getTeamDesignations(this.props.router.params.teamId);
    }
    if (
      this.props.teamdesignationsSuccess ||
      this.props.teamdesignationsFailure
    ) {
      this.props.dispatch({
        type: types.RESET_GET_TEAM_DESIGNATIONS_REQUEST,
      });
      this.getStageFields(this.props.reportDetails);
    }
    if (this.props.getAutoIncrSuccess) {
      this.props.dispatch({
        type: types.RESET_AUTO_INCR_CURR_AND_MAX_LIMIT_REQUEST,
      });
      this.checkAutoIncrCurrMaxLimit();
    }
  }

  /**
   * get report details
   */
  loadData() {
    return new Promise((resolve) => {
      this.props.getReportDetails(
        this.props.router.params.templateId,
        this.props.router.params.teamId,
        resolve
      );
    });
  }

  getLogginedDesigId = () => {
    return this.props.userTeamDetails &&
      this.props.userTeamDetails.designation &&
      this.props.userTeamDetails.designation.designation_id
      ? this.props.userTeamDetails.designation.designation_id
      : null;
  };

  checkAutoIncrCurrMaxLimit = () => {
    const autoIncrDetails =
      !isNull(this.props.autoIncrDetails) &&
      !isNull(this.props.autoIncrDetails['auto_increment_fields']) &&
      this.props.autoIncrDetails['auto_increment_fields'].length > 0
        ? this.props.autoIncrDetails['auto_increment_fields'][0]
        : null;
    if (
      !isNull(autoIncrDetails) &&
      !isNull(autoIncrDetails['current_value']) &&
      !isNull(autoIncrDetails['max_limit']) &&
      autoIncrDetails['current_value'] >= autoIncrDetails['max_limit']
    ) {
      this.setState({
        alertAutoIncrVisible: true,
        disableSubmitButton: true,
        alertAutoIncrMsg:
          autoIncrDetails.message ||
          'Limit reached for this period. Please try again later.',
      });
    }
  };

  /**
   * Stage fields for form0
   */
  getStageFields = async (workflow: any) => {
    const formatTemplate =
      !isNull(workflow) && !isNull(workflow.template)
        ? JSON.parse(workflow.template)
        : null;
    const fields =
      !isNull(formatTemplate) && !isNull(formatTemplate.fields)
        ? formatTemplate.fields
        : [];
    const data: any = [];
    let stageFields: any = [];
    if (isNull(this.props.router.params.stageName)) {
      stageFields =
        !isNull(formatTemplate) &&
        !isNull(formatTemplate.views) &&
        !isNull(formatTemplate.views.create) &&
        !isNull(formatTemplate.views.create.fields)
          ? formatTemplate.views.create.fields
          : [];
    } else {
      const secondaryStages =
        !isNull(formatTemplate) &&
        !isNull(formatTemplate.views) &&
        !isNull(formatTemplate.views.details) &&
        !isNull(formatTemplate.views.details.secondary)
          ? formatTemplate.views.details.secondary
          : [];
      const stage = _.find(secondaryStages, {
        name: this.props.router.params.stageName,
      });
      stageFields = !isNull(stage) && !isNull(stage.fields) ? stage.fields : [];
    }

    const promises: Promise<void>[] = [];

    if (fields.length > 0 && stageFields.length > 0) {
      stageFields.forEach((item: any) => {
        let field = _.find(fields, {
          name: item,
        });
        if (field) {
          /**
           * For status_picker and picker, get stage specific options to render and add -Select- as first value
           */
          if (['status_picker', 'picker'].includes(field.type)) {
            if (field.filter_options && field.filter_options.length > 0) {
              field = this.updateOption(field);
            } else {
              const options =
                field.type === 'picker'
                  ? getPickerDesigOptions(field, this.props.teamdesignations)
                  : field['options'];
              const index = _.findIndex(
                options,
                (option: any) => option === '-Select-'
              );
              if (index === -1) options.unshift('-Select-');
              field['options'] = options;
              if (field.type === 'picker') {
                field['defaultValue'] = getPickerDefaultValue(
                  field,
                  this.props.teamdesignations,
                  this.getLogginedDesigId()
                );
              }
            }
          }

          if (field.type === 'text') {
            const value = getUserDefaultValue(
              field,
              this.props.userTeamDetails,
              this.props.teamdesignations,
              this.getLogginedDesigId()
            );
            if (!isNull(value)) field['defaultValue'] = value;
          }

          if (field.type === 'user_directory') {
            const assignmentType = getAssignmentType(
              field.config.assignment_type
            );
            const stageFormData = !isNull(this.state.formData)
              ? this.state.formData
              : {};
            const allFormData =
              !isNull(this.props.formDataDetails) &&
              !isNull(this.props.formDataDetails.data)
                ? this.props.formDataDetails.data
                : {};
            const recordData =
              !isNull(this.props.router.location) &&
              !isNull(this.props.router.location.state) &&
              !isNull(this.props.router.location.state['fieldValues'])
                ? this.props.router.location.state['fieldValues']
                : {};
            const filter = field['config']['filter'] || '';
            const filterQuery = formatUserFilterQuery(
              assignmentType,
              this.props.userTeamDetails,
              this.props.teamdesignations,
              { ...allFormData, ...recordData, ...stageFormData },
              filter
            );
            const promise = new Promise<void>((resolve, reject) => {
              this.props.getUserDirectoryDesignation(
                filterQuery,
                resolve,
                reject
              );
            }).then((designationData: any) => {
              processUserDirectoryField(
                field,
                designationData,
                this.props.userTeamDetails
              );
            });
            promises.push(promise);
          }
        }

        if (field.type === 'email') {
          const value = getUserDefaultValue(
            field,
            this.props.userTeamDetails,
            this.props.teamdesignations,
            this.getLogginedDesigId()
          );
          if (!isNull(value) && validateEmail(value)) {
            field['defaultValue'] = value;
          } else if (
            isNull(field['defaultValue']) ||
            (!isNull(field['defaultValue']) &&
              !validateEmail(field['defaultValue']))
          ) {
            field['defaultValue'] = '';
          }
        }

        if (field.type === 'phone') {
          const value = getUserDefaultValue(
            field,
            this.props.userTeamDetails,
            this.props.teamdesignations,
            this.getLogginedDesigId()
          );
          if (!isNull(value) && validateMobNumber(value)) {
            field['defaultValue'] = value;
          } else if (
            isNull(field['defaultValue']) ||
            (!isNull(field['defaultValue']) &&
              !validateMobNumber(field['defaultValue']))
          ) {
            field['defaultValue'] = '';
          }
        }
        if (field.type === 'number') {
          if (isNaN(field['defaultValue'])) {
            field['defaultValue'] = '';
          }
        }
        data.push(field);
      });
    }

    await Promise.all(promises);
    this.setState({
      fields: data,
      templateName: this.props.reportDetails.name,
    });
  };
  updateOption = (field: any) => {
    const options = field.filter_options;
    const stage = this.props.router.params.stageName
      ? this.props.router.params.stageName
      : 'create';
    const filterOption = _.find(options, stage);

    if (filterOption) {
      const stageOption = filterOption[stage];
      const index = _.findIndex(
        stageOption,
        (option: any) => option === '-Select-'
      );
      if (index === -1) stageOption.unshift('-Select-');
      field['options'] = stageOption;
    }
    return field;
  };

  scrollToTop = () => {
    setTimeout(() => {
      const element: any = document.getElementById('create-form-root');
      element.scrollIntoView({ behavior: 'smooth' });
    }, 1);
  };

  openCustomDataView = (extProps: any) => {
    this.closeLookupModal();
    this.closeChecklist();
    this.closeSelectModal();
    this.closeUserDirectoryModal();
    this.setState({ openCatalogModal: true, extProps }, () => {
      this.scrollToTop();
    });
  };

  closeCustomDataView = () => {
    this.setState({ openCatalogModal: false });
  };

  openLookupView = (extProps: any) => {
    this.closeCustomDataView();
    this.closeChecklist();
    this.closeSelectModal();
    this.closeUserDirectoryModal();
    this.props.setExtProps(extProps);
    this.setState({ openLookupModal: true, extProps }, () => {
      this.scrollToTop();
    });
  };

  closeLookupModal = () => {
    this.setState({ openLookupModal: false });
  };

  handleClose = () => {
    this.props.resetErrorMessage();
    this.props.resetSuccessMessage();
    this.props.setSelectedFieldValue(false, '');
  };

  getOTPRefFieldData = (allFields: any, allFieldsData: any) => {
    const otpFields = allFields.filter(
      (item: { type: string }) => item.type === 'otp'
    );

    const refFieldNames = otpFields.map(
      (item: any) =>
        item && item.additional_config && item.additional_config.ref_field
    );
    const refData: any = {};
    refFieldNames.length > 0 &&
      refFieldNames.forEach((element: string | number) => {
        if (!isNull(allFieldsData) && !isNull(allFieldsData[element])) {
          refData[element] = allFieldsData[element];
        }
      });
    return refData;
  };

  /**
   * Add checklist view
   */
  openCheckList = (extProps: any) => {
    this.closeCustomDataView();
    this.closeLookupModal();
    this.closeSelectModal();
    this.closeUserDirectoryModal();
    this.setState({ openChecklistModal: true, extProps }, () => {
      this.scrollToTop();
    });
  };

  closeChecklist = () => {
    this.setState({ openChecklistModal: false });
  };

  /**
   * Open select modal
   */
  openSelect = (extProps: any) => {
    this.closeCustomDataView();
    this.closeLookupModal();
    this.closeChecklist();
    this.closeUserDirectoryModal();
    this.setState({ openSelectModal: true, extProps }, () => {
      this.scrollToTop();
    });
  };

  closeSelectModal = () => {
    this.setState({ openSelectModal: false });
  };

  /**
   * Open user directory modal
   */
  openUserDirectory = (extProps: any) => {
    this.closeCustomDataView();
    this.closeLookupModal();
    this.closeChecklist();
    this.closeSelectModal();
    this.setState({ openUserDirectoryModal: true, extProps }, () => {
      this.scrollToTop();
    });
  };

  closeUserDirectoryModal = () => {
    this.setState({ openUserDirectoryModal: false });
  };

  getInstanceId = () => {
    return isNull(this.props.router.params.stageName)
      ? this.instanceId
      : this.props.router.params.instanceId;
  };

  /**
   * Add _mo_instance_id,_mo_start_time and _mo_end_time values to form data
   */
  submitForm = () => {
    const formData = this.formGenerator.getValues();
    if (formData) {
      const endTime = moment().utc().valueOf();
      const recordedTime = moment().utc().valueOf();
      formData['_mo_start_time'] = this.startTime;
      formData['_mo_recorded_at'] = recordedTime;
      formData['_mo_end_time'] = endTime;
      if (isNull(this.props.router.params.stageName)) {
        formData['_mo_instance_id'] = this.instanceId;
        this.props.createFormData(
          this.props.router.params.templateId,
          '',
          formData,
          this.state.isImagePicked
        );
      } else {
        formData['_mo_instance_id'] = this.props.router.params.instanceId;
        this.props.updateFormData(
          this.props.router.params.templateId,
          this.props.router.params.instanceId,
          this.props.router.params.stageName,
          formData,
          this.state.isImagePicked
        );
      }
    }
  };

  getTitle = () => {
    if (!isNull(this.props.router.params.stageName)) {
      return `Update ${
        this.props.reportDetails || this.state.templateName
          ? this.props.reportDetails.name || this.state.templateName
          : ''
      }`;
    }
    return `Create ${this.state.templateName}`;
  };

  getAllFields = () => {
    const formatTemplate =
      !isNull(this.props.reportDetails) &&
      !isNull(this.props.reportDetails.template)
        ? JSON.parse(this.props.reportDetails.template)
        : null;
    return !isNull(formatTemplate) && !isNull(formatTemplate.fields)
      ? formatTemplate.fields
      : [];
  };

  getButtonTitle = () => {
    if (
      this.state.attachmentUploadStatus === 'inProgress' ||
      this.state.docUpload
    ) {
      return `Uploading`;
    } else if (this.state.deleteDocument) {
      return 'Deleting record';
    } else if (!isNull(this.props.router.params.stageName)) {
      return `Update`;
    }
    return `Create`;
  };

  renderComponent = (extProps: any) => {
    const { attributes } = extProps;
    if (attributes && typeof attributes['type'] !== 'undefined') {
      const { type } = attributes;
      switch (type) {
        case 'lookup':
          this.openLookupView(extProps);
          break;
        case 'customDataView':
          this.openCustomDataView(extProps);
          break;
        case 'checklist':
          this.openCheckList(extProps);
          break;
        case 'select':
          this.openSelect(extProps);
          break;
        case 'user_directory':
          this.openUserDirectory(extProps);
          break;
      }
    }
  };

  handleImagesUploadAndDownload = (
    attributes: any,
    doc: any,
    actionType: any
  ) => {
    try {
      if (typeof doc !== 'undefined' && !isNull(doc) && attributes) {
        this.setState({
          attachmentUploadStatus: 'inProgress',
        });

        new Promise((resolve, reject) => {
          this.props.handleImagesUploadAndDownload(
            this.props.router.params.templateId,
            this.props.router.params.teamId,
            this.getInstanceId(),
            attributes['name'],
            doc,
            actionType,
            resolve,
            reject
          );
        })
          .then((data) => {
            if (!isNull(data) && Array.isArray(data) && data.length) {
              this.setState(
                {
                  attachmentUploadStatus: 'done',
                  isImagePicked: actionType === 'write' ? true : false,
                },
                () => {
                  this.formGenerator.onValueChange(attributes['name'], data);
                }
              );
            }
          })
          .catch(() => {
            this.setState(
              {
                attachmentUploadStatus: 'done',
              },
              () => {
                this.formGenerator.onValueChange(attributes['name'], null);
              }
            );
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  callUploadDocument = (attributes: any, doc: any) => {
    try {
      new Promise((resolve, reject) => {
        this.props.handleDocumentUpload(
          this.props.router.params.teamId,
          this.props.router.params.templateId,
          this.getInstanceId(),
          doc,
          resolve,
          reject
        );
      })
        .then((data) => {
          if (!isNull(data) && Array.isArray(data) && data.length) {
            this.setState(
              {
                docUpload: false,
              },
              () => {
                const prevValues = attributes['value']
                  ? attributes['value']
                  : [];
                this.formGenerator.onValueChange(attributes['name'], [
                  ...prevValues,
                  ...data,
                ]);
              }
            );
          }
        })
        .catch(() => {
          this.setState(
            {
              docUpload: false,
            },
            () => {
              const prevValues = attributes['value'] ? attributes['value'] : [];
              this.formGenerator.onValueChange(attributes['name'], prevValues);
            }
          );
        });
    } catch (err) {
      console.log(err);
    }
  };

  handleDocumentUpload = (attributes: any, doc: any) => {
    try {
      if (typeof doc !== 'undefined' && !isNull(doc) && attributes) {
        this.setState({ docUpload: true });
        this.callUploadDocument(attributes, doc);
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleDocumentUpdateAndDownload = (
    attributes: any,
    doc: any,
    actionType: any
  ) => {
    const { type } = attributes;
    switch (type) {
      case 'image':
      case 'signature':
        this.handleImagesUploadAndDownload(attributes, doc, actionType);
        break;
      case 'document':
        this.handleDocumentUpload(attributes, doc);
        break;
      default:
        return;
    }
  };

  handleDeleteDocument = async (attributes: any, doc: any) => {
    try {
      if (typeof doc !== 'undefined' && !isNull(doc) && attributes) {
        const filePath = !isNull(doc['file_path']) ? doc['file_path'] : '';
        if (!isNull(filePath)) {
          this.setState({
            deleteDocument: true,
          });
          const deleteRes = await deleteDocumentFile(
            attributes,
            filePath,
            this.formGenerator
          );
          this.setState({ deleteDocument: deleteRes, deleteDocData: {} });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  handlePreviewDocument = (doc: any) => {
    try {
      downloadDocument(doc);
    } catch (err) {
      console.log(err);
    }
  };

  handleOpenImageModal = (modalImgData: any) => {
    this.setState({ openImgModal: true, modalImgData });
  };

  closeImgModal = () => {
    this.setState({ openImgModal: false, modalImgData: null });
  };

  handleOpenAlertDialog = (msg: string) => {
    this.setState({ openAlertDialog: true, alertMessage: msg });
  };

  closeAlertDailog = () => {
    this.setState({ openAlertDialog: false, alertMessage: '' });
  };

  handleOpenDeleteDocDailog = (data: any) => {
    this.setState({
      deleteDocDialog: true,
      deleteDocData: data,
    });
  };

  closeDeleteDocDailog = (option: string) => {
    if (option === 'yes') {
      this.setState({ deleteDocDialog: false }, () => {
        this.handleDeleteDocument(
          this.state.deleteDocData['attributes'],
          this.state.deleteDocData['doc']
        );
      });
    } else {
      this.setState({
        deleteDocDialog: false,
        deleteDocData: null,
      });
    }
  };

  getOTP = (attributes: any, userName: string, userNameType: string) => {
    new Promise((resolve, reject) => {
      this.props.getOTPForForm(userName, userNameType, resolve, reject);
    })
      .then((data) => {
        attributes['res'] = data;
        const { fields }: { fields: any } = this.state;
        const index = _.findIndex(fields, { name: attributes.name });
        fields[index] = { ...attributes };
        this.setState({ fields: fields });
      })
      .catch((error: any) => {
        console.error('Error fetching OTP:', error);
      });
  };

  getUserDetails = (attributes: any, formData: any) => {
    const assignmentType = getAssignmentType(attributes.config.assignment_type);
    const filter = attributes['config']['filter'] || '';
    const allFormData =
      !isNull(this.props.formDataDetails) &&
      !isNull(this.props.formDataDetails.data)
        ? this.props.formDataDetails.data
        : {};
    const recordData =
      !isNull(this.props.router.location) &&
      !isNull(this.props.router.location.state) &&
      !isNull(this.props.router.location.state['fieldValues'])
        ? this.props.router.location.state['fieldValues']
        : {};
    const filterQuery = formatUserFilterQuery(
      assignmentType,
      this.props.userTeamDetails,
      this.props.teamdesignations,
      { ...allFormData, ...recordData, ...formData },
      filter
    );
    new Promise((resolve, reject) => {
      this.props.getUserDirectoryDesignation(filterQuery, resolve, reject);
    })
      .then((data) => {
        processUserDirectoryField(attributes, data, this.props.userTeamDetails);
        const { fields }: { fields: any } = this.state;
        const index = _.findIndex(fields, { name: attributes.name });

        const updatedAttributes = {
          ..._.cloneDeep(attributes),
          value: attributes.defaultValue || null,
        };
        const updatedFields = [...fields];
        if (index !== -1) updatedFields[index] = updatedAttributes;
        this.setState({ fields: updatedFields });
      })
      .catch((error: any) => {
        console.error('Error fetching getUserDetails:', error);
      });
  };

  render() {
    const returnPath =
      this.props.router.location.state &&
      this.props.router.location.state['returnPath']
        ? this.props.router.location.state['returnPath']
        : 'home';
    return (
      <div id="create-form-root">
        <div className="create-form-wrapper">
          <div className="create-form-header">
            <i
              className="fas fa-arrow-left"
              style={{ paddingRight: '20px' }}
              onClick={() => {
                if (!isNull(this.props.router.params.instanceId)) {
                  this.props.router.navigate(
                    `/member/${this.props.router.params.teamId}/inbox/${this.props.router.params.templateId}/details/${this.props.router.params.instanceId}`
                  );
                } else {
                  this.props.router.navigate(`/member/${returnPath}`);
                }
              }}
            />
            <p>{this.getTitle()}</p>
          </div>
          {this.props.reportDetailsSpinner ||
          this.props.createFormDataSpinner ||
          this.props.getFormDetailsSpinner ||
          this.props.updateFormDataSpinner ||
          this.props.teamdesignationsSpinner ? (
            <Spinner />
          ) : (
            ''
          )}
          <div className="form-content">
            <div className="form-left">
              {!isNull(unsupportedMessage(this.state.fields)) && (
                <p style={{ color: '#FA9917', margin: '10px' }}>
                  {unsupportedMessage(this.state.fields)}
                </p>
              )}
              {this.state.fields.length > 0 ? (
                <Form
                  className="form"
                  ref={(c: any) => (this.formGenerator = c)}
                  fields={this.state.fields}
                  formData={this.state.formData}
                  formSubmissionType={this.getButtonTitle().toLowerCase()}
                  renderComponent={this.renderComponent}
                  handleDocumentUpdateAndDownload={
                    this.handleDocumentUpdateAndDownload
                  }
                  handleOpenImageModal={this.handleOpenImageModal}
                  openAlertModal={this.handleOpenAlertDialog}
                  handleOpenDeleteDocDailog={this.handleOpenDeleteDocDailog}
                  handlePreviewDocument={this.handlePreviewDocument}
                  openSignatureModal={(attributes: any) =>
                    this.setState({
                      openSignatureModal: true,
                      signatureAttributes: attributes,
                    })
                  }
                  getOtp={this.getOTP}
                  getUserDetails={this.getUserDetails}
                  refData={this.state.refData}
                />
              ) : (
                ''
              )}
              <div className="buttons-wrapper">
                <Button
                  className={
                    this.props.createFormDataSpinner ||
                    this.props.updateFormDataSpinner ||
                    this.state.attachmentUploadStatus !== 'done' ||
                    this.state.docUpload ||
                    this.state.deleteDocument ||
                    this.state.disableSubmitButton
                      ? 'form-disabled-button'
                      : 'form-create-button'
                  }
                  onClick={() => {
                    if (!this.state.disableSubmitButton) this.submitForm();
                  }}
                  disabled={
                    this.props.createFormDataSpinner ||
                    this.props.updateFormDataSpinner ||
                    this.state.attachmentUploadStatus !== 'done' ||
                    this.state.docUpload ||
                    this.state.deleteDocument ||
                    this.state.disableSubmitButton
                  }
                >
                  {this.getButtonTitle()}
                </Button>
              </div>
            </div>
            {this.state.openCatalogModal ? (
              <Catalog
                open={this.state.openCatalogModal}
                attributes={
                  this.state.extProps && this.state.extProps['attributes']
                }
                extProps={this.state.extProps}
                closeModal={this.closeCustomDataView}
              />
            ) : null}
            {this.state.openLookupModal ? (
              <Lookup
                attributes={
                  this.state.extProps && this.state.extProps['attributes']
                }
                extProps={this.state.extProps}
                closeModal={this.closeLookupModal}
                isAddLookupEnable={true}
                templateName={this.state.templateName}
              />
            ) : null}

            {this.state.openChecklistModal ? (
              <Checklist
                attributes={
                  this.state.extProps && this.state.extProps['attributes']
                }
                extProps={this.state.extProps}
                closeModal={this.closeChecklist}
              />
            ) : null}

            {this.state.openSelectModal ? (
              <Select
                attributes={
                  this.state.extProps && this.state.extProps['attributes']
                }
                extProps={this.state.extProps}
                closeModal={this.closeSelectModal}
              />
            ) : null}

            {this.state.openUserDirectoryModal ? (
              <UserDirectory
                attributes={
                  this.state.extProps && this.state.extProps['attributes']
                }
                extProps={this.state.extProps}
                closeModal={this.closeUserDirectoryModal}
                data={
                  !isNull(this.props.formDataDetails) &&
                  !isNull(this.props.formDataDetails.data)
                    ? this.props.formDataDetails.data
                    : {}
                }
              />
            ) : null}
            {this.state.openImgModal ? (
              <ImagePreviewModal
                open={this.state.openImgModal}
                closeModal={this.closeImgModal}
                imgObj={this.state.modalImgData}
              />
            ) : (
              ''
            )}
            {this.state.openSignatureModal && (
              <SignatureModal
                closeModal={() => this.setState({ openSignatureModal: false })}
                open={this.state.openSignatureModal}
                attributes={this.state.signatureAttributes}
                handleDocumentUpdateAndDownload={
                  this.handleDocumentUpdateAndDownload
                }
              />
            )}
          </div>
        </div>
        <SnackbarMessage
          handleClose={this.handleClose}
          message={
            this.props.error.displayMessage ||
            this.props.success.displayMessage ||
            this.props.selectedMsg
          }
          open={this.props.open}
        />
        {this.state.openAlertDialog && (
          <AlertDailog
            open={this.state.openAlertDialog}
            message={this.state.alertMessage}
            handleClose={this.closeAlertDailog}
            showNoButton={false}
            yesButtonText={'Ok'}
          />
        )}
        {this.state.deleteDocDialog && (
          <AlertDailog
            open={this.state.deleteDocDialog}
            message={
              'Selected file will be deleted permanently. Are you sure you want to delete'
            }
            handleClose={this.closeDeleteDocDailog}
          />
        )}
        {this.state.alertAutoIncrVisible && (
          <AutoIncrModal
            open={this.state.alertAutoIncrVisible}
            message={this.state.alertAutoIncrMsg}
            closeModal={() => {
              this.setState({
                alertAutoIncrVisible: false,
                alertAutoIncrMsg: '',
              });
              this.props.router.navigate(`/member/${returnPath}`);
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    open: state.reportReducer.open,
    error: state.reportReducer.error,
    success: state.reportReducer.success,
    selectedMsg: state.reportReducer.selectedMsg,
    userTeamDetails: state.homeReducer.userTeamDetails,
    teamUserDetailsSuccess: state.homeReducer.teamUserDetailsSuccess,
    getReportDetailsSuccess: state.reportReducer.getReportDetailsSuccess,
    reportDetailsSpinner: state.reportReducer.reportDetailsSpinner,
    reportDetails: state.reportReducer.reportDetails,
    createFormDataSuccess: state.reportReducer.createFormDataSuccess,
    createFormDataSpinner: state.reportReducer.createFormDataSpinner,
    createFormDataResponse: state.reportReducer.createFormDataResponse,
    timedOut: state.reportReducer.timedOut,
    externalProps: state.reportReducer.externalProps,
    getFormDetails: state.reportReducer.getFormDetails,
    getFormDetailsSpinner: state.reportReducer.getFormDetailsSpinner,
    formDataDetails: state.reportReducer.formDataDetails,
    updateFormDataSuccess: state.reportReducer.updateFormDataSuccess,
    updateFormDataSpinner: state.reportReducer.updateFormDataSpinner,

    teamdesignations: state.reportReducer.teamdesignations,
    teamdesignationsSpinner: state.reportReducer.teamdesignationsSpinner,
    teamdesignationsSuccess: state.reportReducer.teamdesignationsSuccess,
    teamdesignationsFailure: state.reportReducer.teamdesignationsFailure,
    otpFormSuccess: state.reportReducer.otpFormSuccess,
    otpFormFailure: state.reportReducer.otpFormFailure,
    otpFormData: state.reportReducer.otpFormData,

    getAutoIncrReq: state.reportReducer.getAutoIncrReq,
    getAutoIncrSuccess: state.reportReducer.getAutoIncrSuccess,
    autoIncrDetails: state.reportReducer.autoIncrDetails,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
  ...bindActionCreators(
    {
      resetErrorMessage,
      resetSuccessMessage,
      getReportDetails,
      createFormData,
      getTeamUserDetails,
      setExtProps,
      getFormDataDetails,
      updateFormData,
      setSelectedFieldValue,
      handleImagesUploadAndDownload,
      handleDocumentUpload,
      getTeamDesignations,
      getOTPForForm,
      getUserDirectoryDesignation,
      getAutoIncrCurrMaxLimit,
    },
    dispatch
  ),
});

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Form1));
